<template>
  <div>
    <saa ref="saa"></saa>
    <Video @shelly-plug-state-changed="reloadPower" />
  </div>
</template>

<script>
import Video from '@/components/Video';
import Saa from '@/components/Saa.vue';

let timeoutHandle = null;

export default {
  name: 'Home',
  components: {
    Saa,
    Video,
  },
  methods: {
    reloadPower() {
      if (timeoutHandle != null) {
        clearTimeout(timeoutHandle);
      }

      timeoutHandle = setTimeout(() => {
        this.$store.dispatch('shelly/fetchShellyData');
        timeoutHandle = null;
      }, 2000);
    }
  },
  mounted() {
    this.$store.dispatch('shelly/fetchShellyData');
  }
};
</script>
